import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { Postulaciones } from '../../models/postulaciones/postulaciones.model';
import { Curso } from '../../models/curso/curso.model';
import { NacimientoService } from 'src/app/services/nacimiento/nacimiento.service';
import { MatrimonioService } from 'src/app/services/matrimonio/matrimonio.service';
import { CursoService } from '../../services/curso/curso.service';
import { PostulacionesService } from '../../services/postulaciones/postulaciones.service';
import { ProductosService } from 'src/app/services/productos/productos.service';
import { BecasService } from '../../services/becas/becas.service';
import { Usuario } from '../../models/usuario/usuario.model';
import { Beneficiario } from '../../models/beneficiario/beneficiario.model';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import Swal from 'sweetalert2';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { DialogEditPostulacion } from './postulacion-becas-validar.component';
import { TiposService } from '../../services/tipos/tipos.service';
import { DialogEditPostulacionEscolaridad } from './postulaciones-escolaridad-validar.component';
import { DialogEditPostulacionNacimiento } from './postulaciones-nacimiento-validar.component';
import { DialogEditPostulacionMatrimonio } from './postulaciones-matrimonio-validar.component';
import { DialogEditPostulacionFallecimiento } from './postulaciones-fallecimiento-validar.component';
import { DialogEditPostulacionCatastrofe } from './postulaciones-catastrofe-validar.component';
import { AppComponent } from 'src/app/app.component';
import { isNullOrUndefined } from 'util';
import { ModalInfoBeneficiario } from '../common/modal-info-beneficiario.component';
import { environment } from '../../../environments/environment';
import { ModalInfoPagadaBeneficiario } from '../common/modal-info-pagada-beneficiario.component';
import { ConsultaPostulacionesService } from 'src/app/services/consulta-postulaciones/consulta-postulaciones.service';
import { ModalInfoRechazoBeneficiario } from '../common/modal-info-rechazo-beneficiario.component';

@Component({
    selector: 'app-postulaciones-jub',
    templateUrl: '../../pages/postulaciones/postulaciones.component.html',
    styleUrls: ['../../pages/postulaciones/postulaciones.component.css']
})
export class PostulacionesJubComponent implements OnInit {

    idEjecutivo: any = localStorage.getItem("idUsuario")
    postulaciones: any
    tipos: any
    tipoMatrimonios: any    
    postulacionesFinales: any
    postulacionSeleccionada: any
    rol: string = localStorage.getItem("rol")
    idUsuario: string= localStorage.getItem("idUsuario")
    tipoPostulacion: string = "Disponibles"
    estado: any
    tipoProducto: any
    diasDiferencia: any
    tiposBeca: any = []
    config: any = { itemsPerPage: 5, currentPage: 1, totalItems: 5, indexInicial: 0, indexMaximo: 5 }
    allComplete: boolean = false
    regiones: any
    buscador: any =

    {
        tipoProducto:['BECA', 'ESCOLARIDAD', 'NACIMIENTO', 'MATRIMONIO', 'CATASTROFE', 'FALLECIMIENTO'],
        rut:'', region:'', fechaInicio:'', fechaFin:'', itemsPerPage: 5, currentPage:1, idSolicitud:'',
        estado:['INGRESADA', 'PAGADA', 'DISPONIBLE PARA PAGO', 'RECHAZADA', 'APROBADA', 'ANULADA']
    }
   
    constructor(public router: Router, public postulacionesService: PostulacionesService,
        private dialog: MatDialog, private snackBar: MatSnackBar,
        public nacimientoService: NacimientoService,
        public matrimonioService: MatrimonioService, private appComponent: AppComponent,
        private becasService: BecasService, private productosService:ProductosService,
        private cursoService: CursoService, private tiposService: TiposService,public consultaPostulacionesService: ConsultaPostulacionesService) { }

    ngOnInit(): void {
       /* if(localStorage.getItem("jubilado")!='true' && !localStorage.getItem("rol"))
        {
            this.appComponent.logoutJubilado();
        }*/
       
        if (this.rol == "ROLE_AFILIADO" || this.rol == "ROLE_JUBILADO") { 
            console.log('postulacionesAfiliado:',this.rol)
            this.postulacionesAfiliado() 
        }
        
        else {
            console.log('ROLE_AFILIADO:',this.rol)

            this.postulacionesService.traeRegiones().then(regiones => this.regiones = regiones).catch(error => console.log(error))
            this.postulacionesService.traeEstadosSubsidios().then(estado => this.estado = estado).catch(error => console.log(error))
            this.postulacionesService.traeTipoProductoSubsidios(this.idEjecutivo).then(tipoProducto => this.tipoProducto = tipoProducto).catch(error => console.log(error))
            this.buscador.region = "0";
            this.postulacionesDisponibles(true)
           
        }

    }

    buscar() {
        this.buscador.currentPage = 1, this.config.itemsPerPage = 5

        if ((this.buscador.fechaInicio != '' && this.buscador.fechaFin == '')
            || (this.buscador.fechaInicio == '' && this.buscador.fechaFin != '')) {
            this.openAlertDialog('Favor seleccionar fecha de inicio y fecha fin.', 'btn-danger')
            return
        } else {
            let fechaInicial = this.buscador.fechaInicio.split('-')
            let fechaFinal = this.buscador.fechaFin.split('-')
            if (this.buscador.estadoselect.length == 0) {
                this.openAlertDialog('Favor seleccionar al menos un estado.', 'btn-danger')
                return
            }

            if (parseInt(fechaInicial[0] + '' + fechaInicial[1] + '' + fechaInicial[2]) > parseInt(fechaFinal[0] + '' + fechaFinal[1] + '' + fechaFinal[2])) {

                this.openAlertDialog('Favor la fecha de inicio es mayor a la final.', 'btn-danger');
                this.buscador.fechaFin = "";
                return
            }
        }

        if (this.tipoPostulacion == 'Disponibles') this.postulacionesDisponibles(false)
        else this.postulacionesAsignadas(false)
    }

    postulacionesAfiliado() {
        let vm = this
        Swal.fire({
            allowOutsideClick: false,
            icon: 'info',
            text: 'Cargando...'
        });
        Swal.showLoading();
        this.buscador.rut = localStorage.getItem("rutUsuario") + '-' + localStorage.getItem("dvUsuario")
        this.postulacionesService.traePostulacionesDisponibles(localStorage.getItem("username"), this.buscador).then
            (
                (postulaciones: any) => {
                    vm.postulaciones = postulaciones.resultado
                    Swal.close();
                    vm.config.totalItems = vm.postulaciones.cantidadRegistros
                    vm.config.currentPage = this.buscador.currentPage
                }
            )
            .catch(error => {
                vm.postulaciones = []
                vm.config.totalItems = 0
                Swal.close();
              /*  if((error.error.message) && (error.error.message="Token expirado")){
                    vm.openAlertDialog('Su sesión ha finalizado, por favor intente loguearse nuevamente.', 'btn-danger')
                    this.appComponent.logoutJubilado();
                }*/
                console.log(error)
               
            })
    }

    postulacionesDisponibles(recarga?: boolean) {      
        let vm = this
        Swal.fire({
            allowOutsideClick: false,
            icon: 'info',
            text: 'Cargando...'
        });
        Swal.showLoading();
        vm.tipoPostulacion = "Disponibles"
        if (recarga) {
            vm.config.currentPage = 1, vm.buscador.currentPage = 1
            this.buscador.region = "0";
            this.buscador.estadoselect = ['INGRESADA'/*, 'PAGADA', 'DISPONIBLE PARA PAGO', 'RECHAZADA', 'APROBADA'*/];
            /*
            if(this.rol!='ROLE_EJECUTIVO_CAIP'){
                this.buscador.tipoProductoselect = ['ESCOLARIDAD'];
            }else{
                this.buscador.tipoProductoselect = ['BECA', 'NACIMIENTO', 'MATRIMONIO', 'CATASTROFE', 'FALLECIMIENTO'];
            }   */
            this.buscador.tipoProductoselect = ['ESCOLARIDAD'];       
            this.buscador.rut = '';
            this.buscador.fechaInicio = '';
            this.buscador.fechaFin = '';
            this.buscador.idSolicitud = '';

        }
        this.buscador.estado = this.buscador.estadoselect;
      
        this.postulacionesService.traePostulacionesDisponibles(localStorage.getItem("username"), this.buscador).then
            (
                (postulaciones: any) => {
                    console.log(postulaciones)
                    postulaciones.resultado.forEach(postulacion => { postulacion.seleccionado = false })

                    vm.postulaciones = postulaciones.resultado

                    vm.config.currentPage = this.buscador.currentPage
                    vm.config.totalItems = postulaciones.cantidadRegistros

                    vm.postulaciones = postulaciones.resultado
                    vm.buscador.paginasTotal = postulaciones.resultado.length
                    vm.config.currentPage = this.buscador.currentPage
                    vm.buscador.paginasTotal = postulaciones.cantidadPaginas
                    this.buscador.paginasTotal = postulaciones.cantidadPaginas
                    if (this.buscador.currentPage < postulaciones.cantidadPaginas) {
                        this.config.itemsPerPage = postulaciones.resultado.length
                    }
                    Swal.close();
                }
            )
            .catch(error => {
                console.log(error)
                /*if((error.error.message) && (error.error.message="Token expirado")){
                    vm.openAlertDialog('Su sesión ha finalizado, por favor intente loguearse nuevamente.', 'btn-danger')
                    this.appComponent.logoutJubilado();
                }*/
                vm.postulaciones = []
                vm.config.totalItems = 0
                Swal.close();
                if (error.status == 404) vm.openAlertDialog("No se han encontrado postulaciones disponibles.", "btn-dark")
            })
    }

    postulacionesAsignadas(recarga?: boolean) {
        let vm = this
        Swal.fire({
            allowOutsideClick: false,
            icon: 'info',
            text: 'Cargando...'
        });
        Swal.showLoading();
        vm.tipoPostulacion = "Asignadas"


        if (recarga) {
          
            vm.config.currentPage = 1, vm.buscador.currentPage = 1
            this.buscador.region = "0";
            this.buscador.estadoselect = ['EN VALIDACION', 'DISPONIBLE PARA PAGO'];
            this.buscador.tipoProductoselect= ['BECA', 'ESCOLARIDAD', 'NACIMIENTO', 'MATRIMONIO', 'CATASTROFE', 'FALLECIMIENTO'];
            this.buscador.rut = '';
            this.buscador.fechaInicio = '';
            this.buscador.fechaFin = '';
            this.buscador.idSolicitud = '';

        }
        this.buscador.estado = this.buscador.estadoselect;
        this.postulacionesService.traePostulacionesAsignadas(localStorage.getItem("idUsuario"), this.buscador).then
            (
                (postulaciones: any) => {

                    vm.postulaciones = postulaciones.resultado

                    vm.config.totalItems = postulaciones.cantidadRegistros
                    vm.postulaciones = postulaciones.resultado
                    vm.buscador.paginasTotal = postulaciones.resultado.length
                    vm.config.currentPage = this.buscador.currentPage
                    vm.config.totalItems = postulaciones.cantidadRegistros

                    vm.buscador.paginasTotal = postulaciones.cantidadPaginas
                    this.buscador.paginasTotal = postulaciones.cantidadPaginas
                    if (this.buscador.currentPage < postulaciones.cantidadPaginas) {
                        this.config.itemsPerPage = postulaciones.resultado.length
                    }
                    Swal.close();
                }
            )
            .catch(error => {
                console.log(error)
                Swal.close();
                vm.postulaciones = []
                vm.config.totalItems = 0
               /* if((error.error.message) && (error.error.message="Token expirado")){
                    vm.openAlertDialog('Su sesión ha finalizado, por favor intente loguearse nuevamente.', 'btn-danger')
                    this.appComponent.logoutJubilado();
                }*/
            })
    }

    asignarSeleccionados() {
        let postulacionesSeleccionadas: any = []

        if (this.rol != 'ROLE_ADMINISTRADOR') {
            this.openAlertDialog("sólo el perfil administrador puede utilizar esta funcionalidad.", "btn-danger")
            return
        }

        this.postulaciones.filter(pos => pos.seleccionado).forEach(pos => {
            if (pos.estado == 'INGRESADA') {
                postulacionesSeleccionadas.push({ id: pos.posId })
            }
        })
        let vm = this

        if (postulacionesSeleccionadas.length == 0) {
            this.openAlertDialog("Debe seleccionar al menos una postulación y sólo se pueden asignar las postulaciones con el estado INGRESADA.", "btn-danger")
            return
        }
        Swal.fire({
            allowOutsideClick: false,
            icon: 'info',
            text: 'Cargando...'
        });
        Swal.showLoading();

        this.postulacionesService.asignaPostulacion(postulacionesSeleccionadas, this.idEjecutivo).then
            (
                () => {
                    vm.openAlertDialog('La postulación se ha asignado exitosamente.', 'btn-success')
                    vm.postulacionesDisponibles(false)
                    Swal.close();
                }
            )
            .catch(error => {
                Swal.close();
                console.log(error)
               /* if((error.error.message) && (error.error.message="Token expirado")){
                    vm.openAlertDialog('Su sesión ha finalizado, por favor intente loguearse nuevamente.', 'btn-danger')
                    this.appComponent.logoutJubilado();
                }else{*/
                    vm.openAlertDialog('Las postulaciones no se ha podido asignar.', 'btn-danger')
               // }
                
            })

    }

    asignaPostulacion(idPostulacion: any) {
        let postulacion = [{ id: idPostulacion }]

        let vm = this
        Swal.fire({
            allowOutsideClick: false,
            icon: 'info',
            text: 'Cargando...'
        });
        Swal.showLoading();

        this.postulacionesService.asignaPostulacion(postulacion, this.idEjecutivo).then
            (
                () => {
                    vm.openAlertDialog('La postulación se ha asignado exitosamente.', 'btn-success')
                    Swal.close();
                    vm.postulacionesDisponibles(false)
                }
            )
            .catch(error => {
                console.log(error)
                Swal.close();
                /*if((error.error.message) && (error.error.message="Token expirado")){
                    vm.openAlertDialog('Su sesión ha finalizado, por favor intente loguearse nuevamente.', 'btn-danger')
                    this.appComponent.logoutJubilado();
                }else{*/
                    vm.openAlertDialog('La postulación no se ha podido asignar.', 'btn-danger')
                //}
                
            })
    }

    openDialog(idPostulacion: any, nombreProducto: any) {
        const dialogRef = this.dialog.open(ConfirmationDialog,
            {
                data: { message: '¿Esta seguro de anular la solicitud?', buttonText: { ok: 'Si', cancel: 'No' } }
            })

        dialogRef.afterClosed().subscribe((confirmed: boolean) => {
            if (confirmed) {
                const a = document.createElement('a');
                Swal.fire({
                    allowOutsideClick: false,
                    icon: 'info',
                    text: 'Cargando...'
                });
                Swal.showLoading();
                a.click()
                a.remove()
                let idUsuarioSesion = localStorage.getItem("idUsuario")
                let vm = this

                this.postulacionesService.cambiarEstadoPostulacion(idPostulacion, "ANULADA", idUsuarioSesion).then
                    (
                        () => {
                            vm.postulacionesService.traePostulacionesDisponibles(localStorage.getItem("username"), this.buscador).then
                                (

                                    (postulaciones: any) => {
                                        vm.postulaciones = postulaciones;
                                        Swal.close();
                                    }
                                )
                                .catch(error => {
                                    console.log(error)
                                    Swal.close();
                                })

                            vm.openAlertDialog('La postulación se ha anulado exitosamente.', 'btn-success')
                            vm.postulacionesAfiliado()
                        }
                    )
                    .catch(error => {
                        console.log(error)
                      /*  if((error.error.message) && (error.error.message="Token expirado")){
                            vm.openAlertDialog('Su sesión ha finalizado, por favor intente loguearse nuevamente.', 'btn-danger')
                            this.appComponent.logoutJubilado();
                        }else{     */                     
                            vm.openAlertDialog('La postulación no se ha podido anular.', 'btn-danger')
                       // } 
                         Swal.close();
                    })
            }
        })
    }

    detalleBeneficiario(rutAfiliado: any) {
        let data: any = {}

        this.postulacionesService.traeUsuario(rutAfiliado.split('-')[0]).then
            (
                (usu: any) => {
                    console.log(usu)

                    data.nombre = usu.nombres + usu.apellidoPaterno + usu.apellidoMaterno
                    data.telefono = usu.telefonoFijo
                    data.celular = usu.telefonoMovil
                    data.mail = usu.email
                    data.prevision = usu.prevision
                    data.beneficiarios = usu.carga
                }
            )
            .catch(error => console.log(error))

        const dialogRef = this.dialog.open(ModalInfoBeneficiario, { width: '40%', data: data })

        dialogRef.afterClosed().subscribe(() => { })
    }


    detalleRechazoBeneficiario(idPostulacion: any)
  {
    Swal.fire({
      allowOutsideClick:false,
      icon:'info',
      text:'Cargando...'
    });
    Swal.showLoading();

      let data: any = { }

      this.consultaPostulacionesService.traeDataRechazo(idPostulacion).then
      (
          (postulacion: any) =>
          {
              console.log(postulacion)
              data.tipoRechazo=postulacion.motivoRechazo
              data.comentarioRechazo=postulacion.descripcionRechazo
           
          }
      )
      .catch(error => console.log(error))
      Swal.close();
      const dialogRef = this.dialog.open(ModalInfoRechazoBeneficiario, { width: '40%', data: data })

      dialogRef.afterClosed().subscribe( () => {  })
  }


  detalleSolicitudPagada(idPostulacion: any)
  {
    Swal.fire({
      allowOutsideClick:false,
      icon:'info',
      text:'Cargando...'
    });
    Swal.showLoading();

      let data: any = { }

      this.consultaPostulacionesService.traeDataPagada(idPostulacion).then
      (
          (postulacion: any) =>
          {
              console.log(postulacion)
              data.idGrupo=postulacion.id
              data.fechaPago=postulacion.fechaRespuesta           
          }
      )
      .catch(error => console.log(error))
      Swal.close();
      const dialogRef = this.dialog.open(ModalInfoPagadaBeneficiario, { width: '40%', data: data })

      dialogRef.afterClosed().subscribe( () => {  })
  }

    openAlertDialog(mensaje: string, clase: string)
    {
        this.dialog.open(AlertDialogComponent,
            {
                data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' } }
            })
    }

    openEditDialog(idPostulacion: any, nombreProducto: any, mostrarEditar?: any, disponiblePago?: any, tipoProducto?: any): void {

        if (nombreProducto == 'BECA') { this.openDialogBecas(idPostulacion, mostrarEditar, disponiblePago) }
        else if (nombreProducto == 'SUBSIDIO') {
            console.log('tipoProducto')
            if (tipoProducto == 'NACIMIENTO') {
                this.openDialogNacimiento(idPostulacion, mostrarEditar, disponiblePago)
            } else if (tipoProducto == 'MATRIMONIO') {
                    this.openDialogMatrimonio(idPostulacion, mostrarEditar, disponiblePago)
            } else if (tipoProducto == 'FALLECIMIENTO') {
                    this.openDialogFallecimiento(idPostulacion, mostrarEditar, disponiblePago)
            } else if (tipoProducto == 'CATASTROFE') {
                    this.openDialogCatastrofe(idPostulacion, mostrarEditar, disponiblePago)
            } else {              
                this.openDialogEscolaridad(idPostulacion, mostrarEditar, disponiblePago)
            }


        }
    }

    openDialogBecas(idPostulacion: any, mostrarEditar?: any, disponiblePago?: any) {
        let vm = this
        Swal.fire({
            allowOutsideClick: false,
            icon: 'info',
            text: 'Cargando...'
        });

        let mostrarAprobarButton = true;

        if (disponiblePago) {
            mostrarAprobarButton = false;

            if (localStorage.getItem("rol") == 'ROLE_ADMINISTRADOR') {
                disponiblePago = false;
            }

        }
        Swal.showLoading();
        this.postulacionesService.traePostulacionBeca(idPostulacion).then
            (
                (response: any) => {
                    let data: any =
                    {
                        // archivo: response.archivoAdjunto[0],
                        //  archivos: response.archivoAdjunto,
                        idPostulacion: response.id,
                        tipoProducto: response.beca.idTipoBeca,
                        etapaEscolar: response.beca.idCurso,
                        diagnostico: response.beca.diagnosticoEspecial,
                        calificacion: response.beca.calificacion,
                        deshabilitado: true,
                        muestraDiagnostico: response.beca.diagnosticoEspecial ? true : false,
                        presionaEditar: false,
                        carga: response.idUsuario ? false : true,
                        mostrarEditar: mostrarEditar,
                        disponiblePago: !disponiblePago,
                        mostrarAprobarButton: mostrarAprobarButton
                    }

                    vm.tiposService.traeTipos(1).then(tiposBecas => data.tiposBeca = tiposBecas)
                        .catch(errorTipos => console.log(errorTipos))

                    vm.becasService.traePostulantes(response.rutAfiliado).then
                        (
                            (usuario: Usuario) => {
                                data.email = usuario.email
                                data.idUsuario = usuario.id
                                data.nombreCompleto = usuario.nombres + ' ' + usuario.apellidoPaterno

                                if (data.carga) {
                                    let usuariosPostulantes: Array<Usuario> = []

                                    usuario?.carga?.forEach(carga => usuariosPostulantes.push(carga))

                                    data.postulantes = usuariosPostulantes
                                    data.beneficiario = response.idCarga
                                }
                                else {
                                    //data.beneficiario = usuario.id;
                                    data.beneficiario = usuario.nombres + ' ' + usuario.apellidoPaterno
                                }

                                const dialogRef = vm.dialog.open(DialogEditPostulacion, { width: '40%', data: data })
                                Swal.close();
                                dialogRef.afterClosed().subscribe(() => { if (data.recarga) { vm.postulacionesAsignadas(false) } })
                                //  dialogRef.afterClosed().subscribe( () => {  vm.postulacionesAsignadas(data.recarga) })
                            }
                        )
                        .catch(errorPostulantes => {
                            console.log(errorPostulantes)
                          
                            Swal.close();
                        })

                    vm.cursoService.traeCursos(data.tipoProducto).then
                        (
                            (cursos: Curso[]) => {
                                let cursosDisponibles = []

                                if (!data.carga) {
                                    cursos.forEach(curso => { if (curso.postulaAfiliado) cursosDisponibles.push(curso) })
                                }
                                else { cursos.forEach(curso => { if (curso.postulaCarga) cursosDisponibles.push(curso) }) }

                                data.cursos = cursosDisponibles
                            }
                        )
                        .catch(errorCurso => {
                            console.log(errorCurso)
                            Swal.close();
                        })
                }
            )
            .catch(errorPostulacionBeca => {
                console.log(errorPostulacionBeca)
                Swal.close();
            })
    }

    openDialogEscolaridad(idPostulacion: any, mostrarEditar?: any, disponiblePago?: any) {
        var vm = this
        Swal.fire({
            allowOutsideClick: false,
            icon: 'info',
            text: 'Cargando...'
        });
        Swal.showLoading();

        let mostrarAprobarButton = true;
        if (disponiblePago) {
            mostrarAprobarButton = false;
            if (localStorage.getItem("rol") == 'ROLE_ADMINISTRADOR') {
                disponiblePago = false;
            }
        }
        this.postulacionesService.traePostulacionEscolaridad(idPostulacion).then
            (
                (response: any) => {
                    console.log(response)

                    let fecha = response.escolaridad.fechaCertificado?.split('-')

                    let data: any =
                    {
                        //   archivo: response.archivoAdjunto[0], 
                        idPostulacion: response.id,
                        fechaCertificado: fecha[2] + '-' + fecha[1] + '-' + fecha[0],
                        etapaEscolar: response.escolaridad.etapa,
                        deshabilitado: true,
                        cursos: response.idUsuario ? ['MEDIA', 'TECNICO', 'UNIVERSITARIO'] : ['KINDER', 'BASICA', 'MEDIA', 'TECNICO', 'UNIVERSITARIO'],
                        presionaEditar: false,
                        carga: response.idUsuario ? false : true,
                        mostrarEditar: mostrarEditar,
                        disponiblePago: !disponiblePago,
                        mostrarAprobarButton: mostrarAprobarButton
                    }

                    vm.becasService.traePostulantes(response.rutAfiliado).then
                        (
                            (usuario: Usuario) => {
                                data.email = usuario.email
                                data.nombreCompleto = usuario.nombres + ' ' + usuario.apellidoPaterno

                                if (data.carga) {
                                    let usuariosPostulantes: Array<Usuario> = []

                                    usuario.carga.forEach(carga => usuariosPostulantes.push(carga))

                                    data.postulantes = usuariosPostulantes
                                    data.beneficiario = response.idCarga
                                }
                                else {
                                    data.beneficiario = usuario.nombres + ' ' + usuario.apellidoPaterno + ' (' + usuario.rut + '-' + usuario.dv + ')'
                                }
                                this.becasService.obtieneProductos().then
                                    (
                                        productos => productos[2].parametros.map(parametro => {
                                            if (parametro.descripcion == 'DIAS_MAXIMOS_DIFERENCIA_FECHA_DOCUMENTO') {
                                                data.diasDiferencia = parametro.valor
                                            }
                                        })
                                    )

                                const dialogRef = vm.dialog.open(DialogEditPostulacionEscolaridad, { width: '40%', data: data })
                                Swal.close();
                                dialogRef.afterClosed().subscribe(() => { if (data.recarga) { vm.postulacionesAsignadas(false) } })
                                // dialogRef.afterClosed().subscribe( result =>  {  vm.postulacionesAsignadas(data.recarga)  })
                            }
                        )
                        .catch(error => {
                            console.log('SE CAE TRAE POSTULANTES ', error)
                            /*if((error.error.message) && (error.error.message="Token expirado")){
                                vm.openAlertDialog('Su sesión ha finalizado, por favor intente loguearse nuevamente.', 'btn-danger')
                                this.appComponent.logoutJubilado();
                            }*/
                            Swal.close();
                        })
                }
            )
            .catch(error => {
               /* if((error.error.message) && (error.error.message="Token expirado")){
                    vm.openAlertDialog('Su sesión ha finalizado, por favor intente loguearse nuevamente.', 'btn-danger')
                    this.appComponent.logoutJubilado();
                }*/
                console.log("Se cae el traePostulacionEscolaridad", error)
                Swal.close();
            })
    }

    verArchivo(postulacionId: any) {
        let vm = this
        Swal.fire({
            allowOutsideClick: false,
            icon: 'info',
            text: 'Cargando...'
        });
        Swal.showLoading();
        this.postulacionesService.traeArchivos(postulacionId).then
            (
                (archivos: any) => {
                    archivos.forEach(archivo => {
                        var fileURL = `${environment.urlBlob}/${archivo.url}`
                        window.open(fileURL);
                    })
                    Swal.close();
                }
            )
            .catch(error => {
                console.log(error)
               /* if((error.error.message) && (error.error.message="Token expirado")){
                    vm.openAlertDialog('Su sesión ha finalizado, por favor intente loguearse nuevamente.', 'btn-danger')
                    this.appComponent.logoutJubilado();
                }else{*/
                    vm.openAlertDialog('Ha ocurrido un error para visualizar el archivo.', 'btn-danger')    
               // }
                Swal.close();
                
            })
    }

    someComplete(): boolean {
        if (isNullOrUndefined(this.postulaciones?.seleccionado)) { return false }

        return this.postulaciones.filter(p => p.seleccionado).length > 0 && !this.allComplete
    }

    setAll(seleccionado: boolean) {
        this.allComplete = seleccionado

        if (this.postulaciones == null) { return }

        this.postulaciones.forEach(pos => { pos.seleccionado = seleccionado })
    }

    updateAllComplete() {
        this.allComplete = this.postulaciones != null && this.postulaciones
            .slice(this.config.indexInicial, this.config.indexMaximo)
            .every(p => p.seleccionado)
    }

    pageChanged(event: any) {
        this.config.currentPage = event, this.buscador.currentPage = event

        if (this.tipoPostulacion == 'Disponibles') this.postulacionesDisponibles(false)
        else this.postulacionesAsignadas(false)

        this.config.indexInicial = ((this.config.currentPage - 1) * this.config.itemsPerPage)
        this.config.indexMaximo = (this.config.currentPage * this.config.itemsPerPage)
        //this.updateAllComplete()
    }

    cambiaCantidadRegistros() {
        this.config.indexInicial = 0, this.config.indexMaximo = this.config.itemsPerPage, this.config.currentPage = 1
    }


    openDialogMatrimonio(idPostulacion: any, mostrarEditar?: any, disponiblePago?: any) {
        var vm = this
        Swal.fire({
            allowOutsideClick: false,
            icon: 'info',
            text: 'Cargando...'
        });
        Swal.showLoading();

        let mostrarAprobarButton = true;
        if (disponiblePago) {
            mostrarAprobarButton = false;
            if (localStorage.getItem("rol") == 'ROLE_ADMINISTRADOR') {
                disponiblePago = false;
            }
        }
        this.postulacionesService.traePostulacionMatrimonio(idPostulacion).then
            (
                (response: any) => {

                    let fecha = response.matrimonio.fechaMatrimonio?.split('-')
                    let fechaAdop = ''
                
                    let data: any =
                    {
                        idPostulacion: response.id,
                        fechaUnion: fecha[2] + '-' + fecha[1] + '-' + fecha[0],
                        tipoUnion: response.matrimonio.tipoUnion,
                        deshabilitado: true,
                        nombreCompleto: response.matrimonio.nombreCompleto,
                        nombreCompletoConyuge: response.matrimonio.nombreCompletoConyuge,                        
                        rutConyuge: response.matrimonio.rutConyuge,
                        presionaEditar: false,
                        idUsuario: response.idUsuario,
                        carga: response.idUsuario ? false : true,
                        mostrarEditar: mostrarEditar,
                        disponiblePago: !disponiblePago,
                        mostrarAprobarButton: mostrarAprobarButton
                    }

                    vm.becasService.traePostulantes(response.rutAfiliado).then
                        (
                            (usuario: Usuario) => {
                                data.email = usuario.email
                                data.nombreCompleto = usuario.nombres + ' ' + usuario.apellidoPaterno

                                if (data.carga) {
                                    let usuariosPostulantes: Array<Usuario> = []

                                    usuario.carga.forEach(carga => usuariosPostulantes.push(carga))

                                    data.postulantes = usuariosPostulantes
                                    data.beneficiario = response.idCarga
                                }
                                else {
                                    data.beneficiario = usuario.nombres + ' ' + usuario.apellidoPaterno + ' (' + usuario.rut + '-' + usuario.dv + ')'
                                }
                                this.becasService.obtieneProductos().then
                                    (
                                        productos => productos[2].parametros.map(parametro => {
                                            if (parametro.descripcion == 'DIAS_MAXIMOS_DIFERENCIA_FECHA_DOCUMENTO') {
                                                data.diasDiferencia = parametro.valor
                                            }
                                        })
                                    )
                                const dialogRef = vm.dialog.open(DialogEditPostulacionMatrimonio, { width: '40%', data: data })
                                Swal.close();
                                dialogRef.afterClosed().subscribe(() => { if (data.recarga) { vm.postulacionesAsignadas(false) } })

                            }
                        )
                        .catch(error => {
                            console.log('SE CAE TRAE POSTULANTES ', error)
                           /* if((error.error.message) && (error.error.message="Token expirado")){
                                vm.openAlertDialog('Su sesión ha finalizado, por favor intente loguearse nuevamente.', 'btn-danger')
                                this.appComponent.logoutJubilado();
                            }*/
                            Swal.close();
                        })
                }
            )
            .catch(error => {
                console.log("Se cae el traePostulacionNAcimiento", error)
                /*if((error.error.message) && (error.error.message="Token expirado")){
                    vm.openAlertDialog('Su sesión ha finalizado, por favor intente loguearse nuevamente.', 'btn-danger')
                    this.appComponent.logoutJubilado();
                }*/
                Swal.close();
            })
    }


    openDialogCatastrofe(idPostulacion: any, mostrarEditar?: any, disponiblePago?: any) {
        var vm = this
        Swal.fire({
            allowOutsideClick: false,
            icon: 'info',
            text: 'Cargando...'
        });
        Swal.showLoading();

        let mostrarAprobarButton = true;
        if (disponiblePago) {
            mostrarAprobarButton = false;
            if (localStorage.getItem("rol") == 'ROLE_ADMINISTRADOR') {
                disponiblePago = false;
            }
        }
        this.postulacionesService.traePostulacionCatastrofe(idPostulacion).then
            (
                (response: any) => {

                    let fecha = response.catastrofe.fechaCatastrofe?.split('-')  
                           
                    let data: any =
                    {
                        idPostulacion: response.id,
                        fechaCatastrofe: fecha[2] + '-' + fecha[1] + '-' + fecha[0],
                        tipoNacimiento: response.catastrofe.tipoNacimiento,
                        deshabilitado: true,
                        nombreCompletoHijo: response.catastrofe.nombreCompleto,
                        domicilioCatastrofe: response.catastrofe.domicilioCatastrofe,
                        otroTipoCatastrofe: response.catastrofe.otroTipoCatastrofe,
                        caracteristicasVivienda: response.catastrofe.caracteristicasVivienda,
                        tipoVivienda: response.catastrofe.tipoVivienda,
 						magnitudDanno: response.catastrofe.magnitudDanno,
                        visitaDomiciliaria: response.catastrofe.visitaDomiciliaria,
                        observacionCatastrofe: response.catastrofe.observacionCatastrofe,
                        presionaEditar: false,
                        tipoCatastrofe:response.catastrofe.tipoCatastrofe,
                        idUsuario: response.idUsuario,
                        otro: response.catastrofe.otro,                        
                        region: response.catastrofe.idRegion,
                        ciudad: response.catastrofe.idCiudad,
                        comunas: response.comunas,
                        carga: response.idUsuario ? false : true,
                        mostrarEditar: mostrarEditar,
                        disponiblePago: !disponiblePago,
                        mostrarAprobarButton: mostrarAprobarButton
                    }
                  

                    vm.becasService.traePostulantes(response.rutAfiliado).then
                        (
                            (usuario: Usuario) => {
                                data.email = usuario.email
                                data.nombreCompleto = usuario.nombres + ' ' + usuario.apellidoPaterno

                                if (data.carga) {
                                    let usuariosPostulantes: Array<Usuario> = []

                                    usuario.carga.forEach(carga => usuariosPostulantes.push(carga))

                                    data.postulantes = usuariosPostulantes
                                    data.beneficiario = response.idCarga
                                }
                                else {
                                    data.beneficiario = usuario.nombres + ' ' + usuario.apellidoPaterno + ' (' + usuario.rut + '-' + usuario.dv + ')'
                                }
                                this.becasService.obtieneProductos().then
                                    (
                                        productos => productos[2].parametros.map(parametro => {
                                            if (parametro.descripcion == 'DIAS_MAXIMOS_DIFERENCIA_FECHA_DOCUMENTO') {
                                                data.diasDiferencia = parametro.valor
                                            }
                                        })
                                    )
                                const dialogRef = vm.dialog.open(DialogEditPostulacionCatastrofe, { width: '40%', data: data })
                                Swal.close();
                                dialogRef.afterClosed().subscribe(() => { if (data.recarga) { vm.postulacionesAsignadas(false) } })

                            }
                        )
                        .catch(error => {
                            console.log('SE CAE TRAE POSTULANTES ', error)
                            Swal.close();
                        })
                }
            )
            .catch(error => {
                console.log("Se cae el traePostulacionNAcimiento", error)
                /*if((error.error.message) && (error.error.message="Token expirado")){
                    vm.openAlertDialog('Su sesión ha finalizado, por favor intente loguearse nuevamente.', 'btn-danger')
                    this.appComponent.logoutJubilado();
                }*/
                Swal.close();
            })
    }

    openDialogFallecimiento(idPostulacion: any, mostrarEditar?: any, disponiblePago?: any) {
        var vm = this
        Swal.fire({
            allowOutsideClick: false,
            icon: 'info',
            text: 'Cargando...'
        });
        Swal.showLoading();

        let mostrarAprobarButton = true;
        if (disponiblePago) {
            mostrarAprobarButton = false;
            if (localStorage.getItem("rol") == 'ROLE_ADMINISTRADOR') {
                disponiblePago = false;
            }
        }
        this.productosService.obtieneProductos().then
        (
        productos => productos[9].parametros.map(parametro => {
            console.log('parametro1:', parametro)
            if (parametro.descripcion == 'DIAS_MAXIMOS_DIFERENCIA_FECHA_CATASTROFE') {
            vm.diasDiferencia = parametro.valor
            }
        })
        )
        .catch(error => console.log(error))

        
        this.postulacionesService.traePostulacionFallecimiento(idPostulacion).then
            (
                (response: any) => {
                  
                    let beneficiarios: Beneficiario[];
                    let config: any = { itemsPerPage: 5, currentPage: 1, totalItems: 5, indexInicial: 0, indexMaximo: 5 }
                    let beneficiariosArray=response.fallecimiento.fallecimientoBeneficiario;
                    let fecha = response.fallecimiento.fechaFallecimiento?.split('-')
                  
                    let esRecienNacido: boolean = false
                    if (response.fallecimiento.esRecienNacido)
                        esRecienNacido=true

                  
                
                    let data: any =
                    {
                        idPostulacion: response.id,
                        fechaFallecimiento: fecha[2] + '-' + fecha[1] + '-' + fecha[0],
                        beneficiarios: beneficiariosArray,
                        deshabilitado: true,
                        config: config,
                        nombreHijo: response.fallecimiento.nombreHijo,
                        rutHijo: response.fallecimiento.rutHijo,
                        idFallecimiento: response.fallecimiento.idFallecimiento,
                        idCarga: response.idCarga,
                        nacido: response.fallecimiento.esRecienNacido,
                        diasDiferencia:vm.diasDiferencia,
                        scales:esRecienNacido,
                        presionaEditar: false,                                       
                        idUsuario: response.idUsuario,
                        carga: response.idUsuario ? false : true,
                        mostrarEditar: mostrarEditar,
                        disponiblePago: !disponiblePago,
                        mostrarAprobarButton: mostrarAprobarButton
       
                    }
             
                    vm.becasService.traePostulantes(response.rutAfiliado).then
                        (
                            (usuario: Usuario) => {
                                data.email = usuario.email
                                data.nombreCompleto = usuario.nombres + ' ' + usuario.apellidoPaterno

                                if (data.carga) {
                                    let usuariosPostulantes: Array<Usuario> = []

                                    usuario.carga.forEach(carga => usuariosPostulantes.push(carga))

                                    data.postulantes = usuariosPostulantes
                                    data.beneficiario = response.idCarga
                                }
                                else {
                                    data.beneficiario = usuario.nombres + ' ' + usuario.apellidoPaterno + ' (' + usuario.rut + '-' + usuario.dv + ')'
                                }
                                this.becasService.obtieneProductos().then
                                    (
                                        productos => productos[2].parametros.map(parametro => {
                                            if (parametro.descripcion == 'DIAS_MAXIMOS_DIFERENCIA_FECHA_DOCUMENTO') {
                                                data.diasDiferencia = parametro.valor
                                            }
                                        })
                                    )
                                const dialogRef = vm.dialog.open(DialogEditPostulacionFallecimiento, { width: '40%', data: data })
                                Swal.close();
                                dialogRef.afterClosed().subscribe(() => { if (data.recarga) { vm.postulacionesAsignadas(false) } })

                            }
                        )
                        .catch(error => {
                           /* if((error.error.message) && (error.error.message="Token expirado")){
                                vm.openAlertDialog('Su sesión ha finalizado, por favor intente loguearse nuevamente.', 'btn-danger')
                                this.appComponent.logoutJubilado();
                            }*/
                            console.log('SE CAE TRAE POSTULANTES ', error)
                            Swal.close();
                        })
                }
            )
            .catch(error => {
                /*if((error.error.message) && (error.error.message="Token expirado")){
                    vm.openAlertDialog('Su sesión ha finalizado, por favor intente loguearse nuevamente.', 'btn-danger')
                    this.appComponent.logoutJubilado();
                }*/
                console.log("Se cae el traePostulacionNAcimiento", error)
                Swal.close();
            })
    }

    openDialogNacimiento(idPostulacion: any, mostrarEditar?: any, disponiblePago?: any) {
        var vm = this
        Swal.fire({
            allowOutsideClick: false,
            icon: 'info',
            text: 'Cargando...'
        });
        Swal.showLoading();

        let mostrarAprobarButton = true;
        if (disponiblePago) {
            mostrarAprobarButton = false;
            if (localStorage.getItem("rol") == 'ROLE_ADMINISTRADOR') {
                disponiblePago = false;
            }
        }
        this.postulacionesService.traePostulacionNacimiento(idPostulacion).then
            (
                (response: any) => {

                    let fecha = response.nacimiento.fechaNacimiento?.split('-')
                    let fechaAdop = ''
                    if (response.nacimiento.fechaAdopcion) {
                        fechaAdop = response.nacimiento.fechaAdopcion?.split('-')
                    }
                    let data: any =
                    {
                        idPostulacion: response.id,
                        fechaNacimiento: fecha[2] + '-' + fecha[1] + '-' + fecha[0],
                        tipoNacimiento: response.nacimiento.tipoNacimiento,
                        fechaAdopcion: fechaAdop[2] + '-' + fechaAdop[1] + '-' + fechaAdop[0],
                        deshabilitado: true,
                        nombreCompletoHijo: response.nacimiento.nombreCompleto,
                        rutHijo: response.nacimiento.rutHijo,
                        presionaEditar: false,
                        idUsuario: response.idUsuario,
                        carga: response.idUsuario ? false : true,
                        mostrarEditar: mostrarEditar,
                        disponiblePago: !disponiblePago,
                        mostrarAprobarButton: mostrarAprobarButton
                    }

                    vm.becasService.traePostulantes(response.rutAfiliado).then
                        (
                            (usuario: Usuario) => {
                                data.email = usuario.email
                                data.nombreCompleto = usuario.nombres + ' ' + usuario.apellidoPaterno

                                if (data.carga) {
                                    let usuariosPostulantes: Array<Usuario> = []

                                    usuario.carga.forEach(carga => usuariosPostulantes.push(carga))

                                    data.postulantes = usuariosPostulantes
                                    data.beneficiario = response.idCarga
                                }
                                else {
                                    data.beneficiario = usuario.nombres + ' ' + usuario.apellidoPaterno + ' (' + usuario.rut + '-' + usuario.dv + ')'
                                }
                                this.becasService.obtieneProductos().then
                                    (
                                        productos => productos[2].parametros.map(parametro => {
                                            if (parametro.descripcion == 'DIAS_MAXIMOS_DIFERENCIA_FECHA_DOCUMENTO') {
                                                data.diasDiferencia = parametro.valor
                                            }
                                        })
                                    )
                                const dialogRef = vm.dialog.open(DialogEditPostulacionNacimiento, { width: '40%', data: data })
                                Swal.close();
                                dialogRef.afterClosed().subscribe(() => { if (data.recarga) { vm.postulacionesAsignadas(false) } })

                            }
                        )
                        .catch(error => {
                           /* if((error.error.message) && (error.error.message="Token expirado")){
                                vm.openAlertDialog('Su sesión ha finalizado, por favor intente loguearse nuevamente.', 'btn-danger')
                                this.appComponent.logoutJubilado();
                            }*/
                            console.log('SE CAE TRAE POSTULANTES ', error)
                            Swal.close();
                        })
                }
            )
            .catch(error => {
                /*if((error.error.message) && (error.error.message="Token expirado")){
                    vm.openAlertDialog('Su sesión ha finalizado, por favor intente loguearse nuevamente.', 'btn-danger')
                    this.appComponent.logoutJubilado();
                }*/
                console.log("Se cae el traePostulacionNAcimiento", error)
                Swal.close();
            })
    }



}
